export const SECTION_KEYS = [
    'profiles',
    'customers',
    'suppliers',
    'articles',
    'shippingCosts',
    'invoices',
    'bookings',
];

export const SINGLE_SELECT_KEYS = new Set(['profiles']);

export const GROUP_BY_YEAR_KEYS = new Set(['invoices', 'bookings']);

export const SECTION_PAGE_SIZE = 100;

export const SECTION_IMPORT_ORDER = [
    'profiles',
    'customers',
    'suppliers',
    'articles',
    'shippingCosts',
    'invoices',
    'bookings',
];

export const SECTION_KEY_GETTERS = {
    profiles: (item) => item.id,
    customers: (item) => item.id,
    suppliers: (item) => item.id,
    articles: (item) => item.articleNumber,
    shippingCosts: (item) => item.id,
    invoices: (item) => item.id,
    bookings: (item) => item.id,
};

export const SECTION_YEAR_GETTERS = {
    invoices: (item) => item.invoiceDate,
    bookings: (item) => item.date,
};

export const SECTION_PAYLOAD_KEYS = {
    profiles: 'profileIds',
    customers: 'customerIds',
    suppliers: 'supplierIds',
    articles: 'articleNumbers',
    shippingCosts: 'shippingCostIds',
    invoices: 'invoiceIds',
    bookings: 'bookingIds',
};

export const SECTION_LABELS = {
    profiles: 'Profil',
    customers: 'Kunden',
    suppliers: 'Lieferanten',
    articles: 'Artikel',
    shippingCosts: 'Versandkosten',
    invoices: 'Rechnungen',
    bookings: 'Buchungen',
};
